import { useContext, useEffect } from 'react';

import type { QuickReloaderType } from './QuickReloadContext.tsx';
import { QuickReloadContext } from './QuickReloadContext.tsx';

export const useQuickReloadSubscriber = (reloader: QuickReloaderType): void => {
	const { contentId, registerReloader, unregisterReloader } = useContext(QuickReloadContext);

	useEffect(() => {
		registerReloader(reloader);

		return () => {
			unregisterReloader(reloader);
		};

		// NOTE: these are only dependencies of this effect
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [contentId, reloader.name]);
};
